export default __webpack_public_path__ + "static/25-59298e56fad452657eae56e94017d87e.webp";